import { useEffect, useState } from "react";
import { FirestoreService } from "../../../api/firebase/firestoreService";
import { FirestoreCollectionReference } from "../../../api/firebase/references";
import { HealthFacility } from "../types/credentialTypes";

/**
 * Fetches the health facility list on mount.
 *
 * The data is currently consumed only as a side effect (the setter is kept
 * for parity with the original page-level implementation), so this hook
 * intentionally exposes nothing.
 */
export const useFetchHealthFacility = () => {
  const [, setHealthFacilities] = useState<HealthFacility[]>([]);

  useEffect(() => {
    const fetchHealthFacility = async () => {
      try {
        const healthFacilityData = (await FirestoreService.getDocumentsByQuery(
          FirestoreCollectionReference.healthcareFacility(),
          [],
        )) as HealthFacility[];
        setHealthFacilities(healthFacilityData);
      } catch (error) {
        console.error("Error fetching health facility data:", error);
      }
    };

    fetchHealthFacility();
  }, []);
};
